"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    NavDrawerFooter: function() {
        return _index.NavDrawerFooter;
    },
    navDrawerFooterClassNames: function() {
        return _index.navDrawerFooterClassNames;
    },
    useNavDrawerFooterStyles_unstable: function() {
        return _index.useNavDrawerFooterStyles_unstable;
    },
    useNavDrawerFooter_unstable: function() {
        return _index.useNavDrawerFooter_unstable;
    }
});
const _index = require("./components/NavDrawerFooter/index");
